export const soilSampleType = (categoryFA) => {
    switch (categoryFA) {
        case 'آزمایش خاک':
            return 'خاک'
        case 'آزمایش آب':
            return 'آب'
        case 'آزمایش برگ':
            return 'برگ'
        default:
            break
    }
}
